'use client';

import { useTranslations } from 'next-intl';
import { BoxTypeListing } from './box-type-listing';

export function BoxTypesPageContent() {
  const t = useTranslations('boxTypes');

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>
        <p className='text-muted-foreground mt-1'>{t('pageDescription')}</p>
      </div>
      <BoxTypeListing />
    </div>
  );
}
